
import { jsx, css } from '@emotion/react';

import StickyNav from "../oc-sticky-nav";
import Text from './utilities/Text';
import Viewport from "../../PageBuilder/editing/Viewport";

const CMSStickyNav = ({ onClick, selected, cta, items=[] }) => (
  <div css={css`
    a:focus {
      outline-offset: -3px;
    }
    position: sticky;
    z-index: 999;
    top: 0px;

    transition: all 0.2s;
    ${selected && css`
      outline: 3px solid rgba(212,15,125,0);
      outline-offset: 8px;
      outline-color: #D40F7D;
      outline-offset: 14px;
      @media (max-width: ${ Viewport.Screens[Viewport.Device.Desktop] - 1 }px) {
        outline-offset: 11px;
      }
    `}

    & .oc-stickynav {
      margin-left: 0px;
      margin-right: 0px;
    }
  `}
    onClick={ onClick }
  >
    <StickyNav cta={ cta } items={ items } />
  </div>
);

export default CMSStickyNav;
